<template>
<div class="column">
    <h3 class="no-results">לא נמצאו תוצאות</h3>
</div>
</template>

<script>
export default {
  name: `NoResults`
};
</script>

<style>
.no-results {
  text-align: center;
  font-size: 28px;
}
</style>
